import { DominoConfig as DominoConfigModel } from '@models/venue/integrations/DominoConfig'
import { useAppSelector } from '@store/hooks'
import { selectDominoConfigById } from '@store/venue/integrations/DominoConfigReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<DominoConfigModel> & {
  //
}

const DominoConfigAvatar: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectDominoConfigById(id!))

  if (!item) {
    return <></>
  }

  return <Tag>{item.hostApi}</Tag>
}

type DominoConfigAvatarType = { Avatar: typeof DominoConfigAvatar }

export { DominoConfigAvatar, type DominoConfigAvatarType }
